import React from "react"
import {useQuery, useSubscription} from "@apollo/client"
import mediaGetDetails from "graphql/Media/Media/query/mediaGetDetails"
import {FileDetails} from "components/backoffice/Storage/File/Details/FileDetails"

import './style.scss'
import mediaUpdate from "graphql/Media/Media/subscription/mediaUpdate"
import {MediaUpgrade} from "../Upgrade/MediaUpgrade"
import {SubtitleManager} from "./SubtitleManager"

type MediaDetailsProps = {
  mediaId: string,
}

export const MediaDetails = (props: MediaDetailsProps) => {

  useSubscription(mediaUpdate, {
    skip: !props?.mediaId,
    variables: {
      id: props?.mediaId,
    }
  })

  const {data, refetch} = useQuery(mediaGetDetails, {
    skip: !props?.mediaId,
    variables: {
      id: props?.mediaId
    }
  })

  const media = data?.media
  const versionList = media?.Version

  return <div className="media-details-container">
    <header className="media-details-heading"><span className="bo-eyebrow">Bibliothèque</span><h2>Versions du média</h2><p>Fichiers actuellement disponibles pour la lecture.</p></header>
    <div className="media-version-stack">
    {versionList?.map((version: any) => {
      return <article className="media-version-card" key={`version_${version?.id}`}>
        <div className="media-version-icon"><span className="fas fa-film"></span></div>
        <div className="media-version-copy">
          <h3>{version.role || version.language || "Version principale"}</h3>
          <div className="media-version-tags"><span>{version.codec || "legacy"}</span><span>{version.height ? `${version.height}p` : "Résolution inconnue"}</span>{version.isHdr && <span>HDR</span>}</div>
          {version.audioLanguages?.length > 0 && <small>Audio : {version.audioLanguages.join(", ")}</small>}
        </div>
        <FileDetails File={version?.File} />
      </article>
    })}
    {!versionList?.length && <div className="media-version-empty">Aucune version disponible.</div>}
    </div>
    <MediaUpgrade mediaId={props.mediaId} />
    <SubtitleManager mediaId={props.mediaId} subtitles={media?.Subtitle || []} onImported={refetch} />
  </div>
}
